import ReactDOM from "react-dom";
import { useEffect, useState } from "react";
import ModalHeader from "./modalHeader";

const modalRoot = document.getElementById("modal-root");

const CustomModal = ({ isOpen, onClose, children, modalTitle }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      setTimeout(() => setShowModal(true), 10);
    } else {
      setShowModal(false);
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 bg-black bg-opacity-70 z-[999] transition-opacity duration-300 ${
        showModal ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div
        className={`absolute top-1/2 left-1/2 bg-white py-5 rounded-lg max-w-[500px] w-[90%] transform -translate-x-1/2 -translate-y-1/2 transition-all duration-300 px-5 ${
          showModal ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <ModalHeader modalTitle={modalTitle} onClose={onClose} />
          <div className="overflow-y-auto pt-3">{children}</div>
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export default CustomModal;
